import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import styles from './AuthButton.module.scss'

type AuthButtonProps = {
  className?: string
  label: React.ReactNode
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type']
  variant?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const AuthButton = ({
  className,
  label,
  type = 'button',
  variant,
  onClick,
}: AuthButtonProps) => (
  <Button
    className={cx(styles.button, styles.variant, {
      [styles[variant ?? '']]: Boolean(variant),
      [className ?? '']: Boolean(className),
    })}
    color="primary"
    size="medium"
    {...{ label, type, variant, onClick }}
  />
)
